import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import MyRewards from '@src/quince-site-integrated/src/templates/Account/my-rewards'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.MY_REWARDS)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageAccountsMyRewards(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return <Layout {...props}>{props.pageData ? <MyRewards data={props.pageData} /> : <SomethingWentWrong />}</Layout>
}
